export enum BuildingTypeEnum {
  InUse,
  NotInUse = 2,
  EmptyParcel,
  NoAccess,
  StudentHome,
  InUseWithoutBuildingUnit,
}
